import React, { useEffect, useState } from 'react';
import { useRecoilState } from 'recoil';
import { useHistory, Redirect } from 'react-router-dom';
import { formatDatetime } from '../../utils/common';

//api
import { getFileTypes, editFileTypeById } from '../../apicalls/cloud/fileType';
//components
import { EditFileTypeField } from './EditFileType';
import { DeleteFileTypeField } from './DeleteFileType';

//material ui
import {
  Button,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Modal
} from '@material-ui/core';
import { makeStyles, withStyles, createStyles } from '@material-ui/core/styles';

type TProps = {
  fileTypes: any;
  getAllFileTypes: any;
};

// 資料種別フォルダリスト
export const FileTypeListField = (props: TProps) => {
  const classes = useStyles();
  // エラーメッセージ
  const [errorMessage, setErrorMessage] = useState('');
  // エラーメッセージ表示フラグ
  const [open, setOpen] = useState(false);

  // モーダル開閉用
  const [openEditFileTypeModal, setOpenEditFileTypeModal] =
    useState<boolean>(false);
  const [openDeleteFileTypeModal, setOpenDeleteFileTypeModal] =
    useState<boolean>(false);
  // 資料種別一覧
  const { fileTypes, getAllFileTypes } = props;
  // 資料種別情報
  const [fileTypeId, setFileTypeId] = useState<number>(0);
  const [fileTypeName, setFileTypeName] = useState<string>('');
  const [fileTypeCount, setFileTypeCount] = useState<number>(0);

  return (
    <>
      <Grid container>
        <Grid
          item
          xs={12}
          style={{
            backgroundColor: '#FFFFFF',
            borderTop: '1px solid #f5f5f5',
            borderBottom: '1px solid #f5f5f5',
            padding: '30px 20px'
          }}
        >
          {fileTypes.length === 0 ? (
            <div>フォルダに書類がありません</div>
          ) : (
            <TableContainer component={Paper}>
              <Table className={classes.main} aria-label='customized table'>
                <TableHead>
                  <TableRow>
                    <StyledTableCell className={classes.table} align='center'>
                      名前
                    </StyledTableCell>
                    <StyledTableCell className={classes.table} align='center'>
                      格納数
                    </StyledTableCell>
                    <StyledTableCell className={classes.table} align='center'>
                      作成日
                    </StyledTableCell>
                    <StyledTableCell
                      className={classes.table}
                      align='center'
                    ></StyledTableCell>
                    <StyledTableCell
                      className={classes.table}
                      align='center'
                    ></StyledTableCell>
                  </TableRow>
                </TableHead>

                {fileTypes.map((type: any) => (
                  <TableBody>
                    <StyledTableRow className='click_table_row' title='編集'>
                      <StyledTableCell
                        className={classes.table1}
                        style={{ minWidth: 60 }}
                        align='center'
                      >
                        {type.name}
                      </StyledTableCell>
                      <StyledTableCell
                        className={classes.table1}
                        style={{ minWidth: 60 }}
                        align='center'
                      >
                        {type.file_count}
                      </StyledTableCell>
                      <StyledTableCell
                        className={classes.table1}
                        style={{ minWidth: 90 }}
                        align='center'
                      >
                        {formatDatetime(
                          new Date(type.created_at),
                          'YYYY年MM月DD日',
                          '日本標準時'
                        )}
                      </StyledTableCell>
                      <StyledTableCell
                        className={classes.table1}
                        style={{ minWidth: 90 }}
                        align='right'
                      ></StyledTableCell>
                      <StyledTableCell
                        className={classes.table1}
                        style={{ minWidth: 60 }}
                        align='right'
                      >
                        <Button
                          variant='contained'
                          style={{ marginRight: 24 }}
                          onClick={() => {
                            setFileTypeId(type.id);
                            setFileTypeName(type.name);
                            setOpenEditFileTypeModal(true);
                          }}
                        >
                          編集
                        </Button>
                        <Button
                          variant='contained'
                          onClick={() => {
                            setFileTypeId(type.id);
                            setFileTypeName(type.name);
                            setFileTypeCount(type.file_count);
                            setOpenDeleteFileTypeModal(true);
                          }}
                        >
                          削除
                        </Button>
                      </StyledTableCell>
                    </StyledTableRow>
                  </TableBody>
                ))}
              </Table>
            </TableContainer>
          )}
        </Grid>
      </Grid>
      {/* 種別名変更モーダル */}
      <Modal
        open={openEditFileTypeModal}
        onClose={() => setOpenEditFileTypeModal(false)}
        aria-labelledby='simple-modal-title'
        aria-describedby='simple-modal-description'
        className={classes.container}
      >
        <EditFileTypeField
          fileTypeId={fileTypeId}
          fileTypeName={fileTypeName}
          openEditFileTypeModal={openEditFileTypeModal}
          setOpenEditFileTypeModal={setOpenEditFileTypeModal}
          getAllFileTypes={getAllFileTypes}
        />
      </Modal>
      {/* 種別削除モーダル */}
      <Modal
        open={openDeleteFileTypeModal}
        onClose={() => setOpenDeleteFileTypeModal(false)}
        aria-labelledby='simple-modal-title'
        aria-describedby='simple-modal-description'
        className={classes.container}
      >
        <DeleteFileTypeField
          fileTypeId={fileTypeId}
          fileTypeName={fileTypeName}
          fileTypeCount={fileTypeCount}
          fileTypes={fileTypes}
          openDeleteFileTypeModal={openDeleteFileTypeModal}
          setOpenDeleteFileTypeModal={setOpenDeleteFileTypeModal}
          getAllFileTypes={getAllFileTypes}
        />
      </Modal>
    </>
  );
};

// ----------スタイル----------------

const StyledTableCell = withStyles(theme => ({
  head: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white
  },
  body: {
    fontSize: 16
  }
}))(TableCell);

const StyledTableRow = withStyles(theme => ({
  root: {
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.action.hover
    }
  }
}))(TableRow);

const useStyles = makeStyles(() =>
  createStyles({
    formControl: {
      minWidth: 120,
      backgroundColor: '#FFFFFF'
    },
    formControl1: {
      minWidth: 120,
      height: 30,
      borderRadius: 5,
      borderWidth: 1,
      paddingLeft: 5
    },
    main: {
      minWidth: 700
    },
    table: {
      backgroundColor: `#0099CC !important`,
      color: '#FFFFFF',
      padding: 10,
      fontWeight: 'bold',
      fontSize: 16
    },
    table1: {
      padding: 8
    },
    container: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: 15
    }
  })
);
